export const fileType = {
  image: /\.(jpg|jpeg|png|bmp|heic|heif|tiff|svg|psd|webp|avif)$/i,
  video:
    /\.(mp4|avi|mkv|wmv|vob|flv|wmv9|mpeg|3gp|webm|hevc|mov|mpg|3gpp|mpeg1|mpeg2|mpeg4|mpegps)$/i,
  file: /\.(pdf|xlsx|xls|doc|docx|pptx|dwg|kmz|wma)$/i,
  viewFileSupport: /\.(pdf|xlsx|xls|doc|docx|pptx)$/i,
  resizeImageSupport: /\.(jpg|jpeg|png)$/i,
};
